import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(landing)/nl/pricing/page.tsx");
